import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";

import { auth } from "../../utils/auth";
import { getLink, getSucursal } from "../../utils/helpers";
import { withRequest } from "../../utils/request";

class DesktopHeader extends Component {
    setSucursal = async (sid) => {
        const res = await this.props.request("sset?sid=" + sid);

        if (res.success) {
            window.localStorage.setItem("sucursalActual", res.data.id);
            window.location = "/" + res.data.id;
        }
    };
    render() {
        const usuario = auth.getUser();
        return (
            <header className='header-desktop'>
                <div className='section__content section__content--p30'>
                    <div className='container-fluid'>
                        <div className='header-wrap'>
                            {usuario.sucursales.length > 1 ? (
                                <div className='sucursales-header'>
                                    {usuario.sucursales.map((sucursal) => (
                                        <button
                                            key={sucursal.id}
                                            className={
                                                "btn " +
                                                (parseInt(getSucursal()) ===
                                                sucursal.id
                                                    ? "btn-primary"
                                                    : "")
                                            }
                                            onClick={() =>
                                                this.setSucursal(
                                                    sucursal.id
                                                )
                                            }>
                                            {sucursal.nombre}
                                        </button>
                                    ))}
                                </div>
                            ) : (
                                <div>{usuario.sucursales[0].nombre}</div>
                            )}
                            {auth.can("ver-reportes") && (
                                <div className='reportes text-right'>
                                    <button
                                        type='button'
                                        className='au-btn au-btn-icon au-btn-filter m-r-10'
                                        onClick={() =>
                                            this.props.toggleModal(
                                                "showReportes"
                                            )
                                        }>
                                        <i className='fas fa-file-alt' />
                                        Reportes
                                    </button>
                                </div>
                            )}
                            <div
                                className='header-button'
                                onClick={() =>
                                    this.props.toggleModal(
                                        "showReportes",
                                        false
                                    )
                                }>
                                <div
                                    className='account-wrap'
                                    onBlur={this.onClickUserMenu}>
                                    <UserDropDown
                                        history={this.props.history}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

class UserDropDown extends Component {
    state = {
        show: false,
    };
    UNSAFE_componentWillMount() {
        document.addEventListener("mousedown", this.handleClick, false);
    }
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClick, false);
    }
    handleClick = (e) => {
        if (this.node.contains(e.target)) {
            this.setState({ show: true });
            return;
        }
        this.setState({ show: false });
    };
    render() {
        const dropdownClass = this.state.show ? "show-dropdown" : "";
        const usuario = auth.getUser();
        return (
            <div
                className={`account-item clearfix js-item-menu ${dropdownClass}`}
                ref={(node) => (this.node = node)}>
                <div className='content'>
                    <span className='js-acc-btn'>
                        Hola, {usuario.nombre}{" "}
                        <i className='fas fa-angle-down'></i>
                    </span>
                </div>
                <div className='account-dropdown js-dropdown'>
                    <div className='info clearfix'>
                        <div className='content'>
                            <h5 className='name'>
                                {`${usuario.nombre} ${usuario.apellido}`}
                            </h5>
                            <span className='email'>{usuario.email}</span>
                        </div>
                    </div>
                    {auth.can("ver-configuracion") && (
                        <div className='account-dropdown__body'>
                            <div className='account-dropdown__item'>
                                <Link to={getLink("/configuracion")}>
                                    <i className='zmdi zmdi-settings'></i>
                                    Configuración
                                </Link>
                            </div>
                        </div>
                    )}
                    <div className='account-dropdown__footer'>
                        <button onClick={auth.logout}>
                            <i className='zmdi zmdi-power'></i>Logout
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(withRequest(DesktopHeader));
